import { useEffect } from 'react';
import initialGTM from '../../../../../utils/initialGTM';
import { useRootSelector } from '../../../../../store/hooks';
import { selectPageConfig } from '../../../../../store/features/pageConfig';
import { SiteTypes } from '../../../../../types';

const GTM = initialGTM.gtm;

export interface UseDivisionGTMProps {
  divisionId: string;
  divisionInfrontBusinessUnit: string;
  divisionName: string;
  disablePushDataToGTM?: boolean;
}

export const useDivisionGTM = (props: UseDivisionGTMProps) => {
  const {
    divisionId,
    divisionInfrontBusinessUnit,
    divisionName,
    disablePushDataToGTM,
  } = props;
  const { siteType } = useRootSelector(selectPageConfig);

  useEffect(() => {
    if (!disablePushDataToGTM && siteType === SiteTypes.COURSE) {
      if (divisionId) {
        GTM.dataLayer({
          dataLayer: {
            'divisionOption.id': divisionId,
          },
        });
      }

      if (divisionName) {
        GTM.dataLayer({
          dataLayer: {
            'divisionOption.name': divisionName,
          },
        });
      }

      if (divisionInfrontBusinessUnit) {
        GTM.dataLayer({
          dataLayer: {
            'divisionOption.infrontBusinessUnit': divisionInfrontBusinessUnit,
          },
        });
      }
    }
    // eslint-disable-next-line
  }, []);
};
